import PdfGenerator from './PdfGenerator';
import Moment from 'moment';

class MovimentiTotali extends PdfGenerator {

    constructor(){
        super();
        this.orientation = 'p';
        this.doDrawCell = this.doDrawCell.bind(this);
        this.doDrawRow = this.doDrawRow.bind(this);
    }

    doDrawCell(cell, data){
        if (data.row.raw.id === '' && (data.row.raw.data ==='TP' || data.row.raw.data ==='TF')){
            if (data.column.dataKey === 'ecorrispettivo'){
                //data.doc.setFontStyle('bold');
            }
            if (data.column.dataKey === 'epagamento'){
                data.doc.setFontStyle('bold');
            }
            if (data.column.dataKey === 'ucorrispettivo'){
                //data.doc.setFontStyle('bold');
            }
            if (data.column.dataKey === 'upagamento'){
                data.doc.setFontStyle('bold');
            }
            if (data.column.dataKey === 'saldoImp'){
                //data.doc.setFontStyle('bold');
            }
            if (data.column.dataKey === 'saldoTot'){
                data.doc.setFontStyle('bold');
            }
            if (data.column.dataKey === 'categoria' && (data.row.raw.voce === '' && data.row.raw.sottovoce === '')){
                data.doc.setFontStyle('bold');
            }
        }
    }

    doDrawRow(row, data){
        let doc = data.doc;
        if (data.row.raw.id === ''){

            if (data.row.raw.data ==='TP' || data.row.raw.data ==='TF'){
                if (data.row.raw.voce === '' && data.row.raw.sottovoce === ''){
                    doc.setFillColor(0);
                    doc.rect(data.settings.margin.left, row.y+2, data.table.width, 1 , 'F');
                    data.cursor.y += 0;
                }
                if (data.row.raw.categoria === '' && data.row.raw.voce === '' && data.row.raw.sottovoce === ''){
                    doc.setFillColor(0);
                    doc.rect(data.settings.margin.left, row.y+2, data.table.width, 1 , 'F');
                    data.cursor.y += 0;
                }
            }
            if (data.row.raw.data === 'H1'){
                let height = row.height+5;
                doc.setFillColor(255);
                doc.rect(data.settings.margin.left, row.y, data.table.width, height , 'F');
                doc.setFontStyle('bold');
                doc.setFontSize('14');
                //doc.text(data.row.raw.note, data.settings.margin.left, row.y + height / 2);
                doc.autoTableText(data.row.raw.forma, data.settings.margin.left , row.y + height/2, {
                    halign: 'left',
                    valign: 'middle'
                });
                doc.setFillColor(0);
                doc.rect(data.settings.margin.left, row.y + height-2, data.table.width, 2 , 'F');
                data.cursor.y += height;
                return false;
            }
            else if (data.row.raw.data === 'H2'){
                if (data.row.raw.forma === '-'){
                    return false;
                }
                let height = row.height;
                doc.setFillColor(255);
                doc.rect(data.settings.margin.left, row.y, data.table.width, height , 'F');
                doc.setFontStyle('bold');
                doc.setFontSize('12');
                //doc.text(data.row.raw.note, data.settings.margin.left, row.y + height / 2);
                doc.autoTableText('__' + data.row.raw.forma, data.settings.margin.left , row.y + height/2, {
                    halign: 'left',
                    valign: 'middle'
                });
                data.cursor.y += height;
                return false;
            }
            else if (data.row.raw.data === 'H3'){
                if (data.row.raw.forma === '-'){
                    return false;
                }
                let height = row.height;
                doc.setFillColor(255);
                doc.rect(data.settings.margin.left, row.y, data.table.width, height , 'F');
                doc.setFontStyle('bold');
                doc.setFontSize('12');
                //doc.text(data.row.raw.note, data.settings.margin.left, row.y + height / 2);
                doc.autoTableText('____' + data.row.raw.forma, data.settings.margin.left , row.y + height/2, {
                    halign: 'left',
                    valign: 'middle'
                });
                data.cursor.y += height;
                return false;
            }
            else {
                doc.setFontStyle('bold');
                row.height -= 5;
            }
        }
        else {
            row.height -= 5;
        }
    }

    createPdf(data){

        this.setTitle("Report riassuntivo movimenti per PDC");

        let srcrows = data.rows;
        let ultimaModifica = data.ultimaModificaInfo;

        if (ultimaModifica){
            this.ultimaModificaText = ' - U.m. del ' + Moment(ultimaModifica.modificatoIl).format("DD/MM/YYYY HH:mm") + ' ' + ultimaModifica.modificatoDa.username;
        }
        const columns = [
            {title: "categoria", dataKey: "categoria"},
            {title: "voce", dataKey: "voce"},
            {title: "sottovoce", dataKey: "sottovoce"},
            {title: "Saldo\nCorrispettivo", dataKey: "saldoImp"},
            {title: "Saldo\nPagamento", dataKey: "saldoTot"},
        ];
        let rows = [];
        srcrows.map((r) => {
            if (r.id === ''){
                if (r.data ==='TP' || r.data === 'TF'){
                    r.ecorrispettivo = this.formatCurrency(r.ecorrispettivo);
                    r.epagamento = this.formatCurrency(r.epagamento);
                    r.ucorrispettivo = this.formatCurrency(r.ucorrispettivo);
                    r.upagamento = this.formatCurrency(r.upagamento);
                    r.saldoImp = this.formatCurrency(r.saldoImp, 0);
                    r.saldoTot = this.formatCurrency(r.saldoTot, 0);
                    // if (r.categoria === '' && r.voce === '' && r.sottovoce === ''){
                    //     r.categoria ="TOTALI GENERALI";
                    // }
                    if ((r.sottovoce !== '' && r.categoria !== '' && r.voce !== '' ) ||
                        (r.categoria !== '' && r.sottovoce === '' && r.voce === '') ||
                        (r.data === 'TF')){
                        rows.push(r);
                    }
                }
                else if(r.data === 'H1'){
                    rows.push(r);
                }
                // if (r.sottovoce !== '' && r.sottovoce !== '-'){
                //     rows.push(r);
                // }
                // rows.push(r);
            }
            return 0;
        });

        super.createPdf(columns, rows,
            {
                theme: 'plain',
                drawRow: this.doDrawRow,
                drawCell: this.doDrawCell,
                styles: {
                    overflow: 'linebreak',
                    columnWidth: 'wrap',
                    fontSize: 7,
                },
                columnStyles: {
                    categoria: {halign: 'left', columnWidth: '35', overflow: 'hidden'},
                    voce: {halign: 'left', columnWidth: '40', overflow: 'hidden'},
                    sottovoce: {halign: 'left', columnWidth: '40', overflow: 'hidden'},
                    // ecorrispettivo: {halign: 'right'},
                    // epagamento: {halign: 'right'},
                    // ucorrispettivo: {halign: 'right'},
                    // upagamento: {halign: 'right'},
                    saldoImp: {halign: 'right'},
                    saldoTot: {halign: 'right'},
                }
            });
    }
}

export default MovimentiTotali;


/** WEBPACK FOOTER **
 ** ./src/pdf/MovimentiTotali.js
 **/